import React from 'react';
import TextField from '@mui/material/TextField';
import { getFormFieldError, isFormFieldInvalid } from '../../helpers/validators';

// use this component with setFieldData rff mutator
const FRUSTextFieldWrapper = ({
  input: { name, onChange, onFocus, value, ...restInput },
  autoComplete = false,
  meta,
  classes,
  ...rest
}) => {
  const showError = isFormFieldInvalid(meta);

  return (
    <TextField
      variant="standard"
      {...rest}
      name={name}
      helperText={showError ? getFormFieldError(meta) : undefined}
      error={showError}
      inputProps={{
        ...restInput,
        autoComplete: autoComplete || 'chrome-off',
      }}
      sx={[
        showError && {
          background: '#f443360f',
          borderRadius: 2,
        },
      ]}
      onFocus={onFocus}
      onChange={event => {
        meta.data.error = undefined;
        if (onChange) {
          onChange(event);
        }
      }}
      value={value}
    />
  );
};

export default FRUSTextFieldWrapper;
